import Config from "./config";
const awsConfig = {
    Auth: Config.AWS_CONFIG
};
export default awsConfig;